module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "decade-nav"
  }, [_c('ul', _vm._l((_vm.decades), function(decade) {
    return _c('li', {
      key: decade,
      class: {
        'selected': _vm.selectedDecade === decade,
        'hovered': !_vm.timelineTransitioning && _vm.hoveredDecade === decade
      },
      on: {
        "mouseenter": function($event) {
          return _vm.hoverDecade(decade)
        },
        "mouseleave": _vm.unhoverDecade
      }
    }, [_c('a', {
      attrs: {
        "href": '#' + decade + 's'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleNavClick(decade)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(decade + 's'))])])])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-659de8d1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659de8d1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./timeline/js/components/DecadeNav.vue
// module id = 48
// module chunks = 0